export default __webpack_public_path__ + "static/PromptIconFour-06dc3cf38299826004254d7f74ae840c.png";